import PageCard, { PageCardProps } from "./PageCard";

export default function ContractPageCard(props: Omit<PageCardProps, "menu">) {
  return <PageCard {...props} />;
}
